import React, { useState } from 'react';
import getTaskColor from '../utils/TaskColor';
import getTaskButtonColor from '../utils/TaskButtonColor';
import styles from '../styles/TaskItem.module.css';
import useUserPokemons from '../hooks/Pokemons/useUserPokemon';


const TaskItem = ({ task, onDelete, pokemon }) => {
    const userPokemons = useUserPokemons();
    const [isSelected, setIsSelected] = useState(false);

    const selectTask = () => {
        setIsSelected(!isSelected);
    };

    const handleClick = (e) => {
        e.stopPropagation(); // Empêche le déclenchement du selectTask
        const element = document.getElementById(`task-${task.id}`);
        element.classList.add(styles.fadeOut);
        setTimeout(onDelete, 200);
    };

    // Création d'une classe conditionnelle pour le conteneur principal
    const taskItemClasses = `${styles.taskItem} ${isSelected ? styles.selected : ''}`;
    const taskDescriptionClasses = `${styles.descriptionContainer} ${isSelected ? styles.visible : ''}`; // Classe css conditionnelle pour la description

    if (!userPokemons) return <p>Chargement des Pokémon...</p>;

    if (!pokemon) {
        console.log('Pokemon non trouvé pour la tâche:', task);
        return null;
    }

    return (
        <div 
            id={`task-${task.id}`} 
            className={taskItemClasses}
            onClick={selectTask} 
            style={{ 
                border: `4px solid ${getTaskColor(task.difficulty)}`,
                backgroundColor: isSelected ? getTaskColor(task.difficulty) : 'transparent'
            }}
        >
            <div className={styles.taskItemContent}>
                <div className={styles.title}>
                    <p>{task.title}</p>
                </div>
                <div className={taskDescriptionClasses}>
                    {task.description && <p>{task.description}</p>}
                    <div className={styles.buttonContainer}>
                        <div className={styles.button} style={{ backgroundColor: getTaskButtonColor(task.difficulty) }} onClick={handleClick}>Terminer</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TaskItem;